<template>
    <!-- 线上 -->
    <Modal v-model="visible" title="变更记录" :footer-hide="true" width="1150" class="my-modal p-d top">
        <Tabs v-model="tabsValue" :animated="false" @on-click="changeTabs">
            <TabPane label="信息变更记录" name="info">
                <info ref="infoRef" :policyNo="formData.policyNo"></info>
            </TabPane>
            <TabPane label="状态变更记录" name="status">
                <status ref="statusRef" :policyNo="formData.policyNo"></status>
            </TabPane>
            <!-- <TabPane label="业务员变更记录" name="salesman">
                <salesman ref="salesmanRef" :policyNo="formData.policyNo"></salesman>
            </TabPane> -->
        </Tabs>
    </Modal>
</template>

<script>
import info from './info';
import status from './status';
import salesman from './salesman';
export default {
    components: {
        info,
        status,
        salesman
    },
    data() {
        return {
            tabsValue: 'info',
            visible: false,
            formData: {} //传入参数
        };
    },

    methods: {
        open(data = {}) {
            this.formData = JSON.parse(JSON.stringify(data));
            this.visible = true;
            this.tabsValue = 'info';
            this.$refs.infoRef.searchParams = {
                pageNo: 1,
                pageSize: 10,
                type: '1',
                policyNo: data.policyNo
            };
            this.$refs.infoRef.getInitList();
            this.$refs.infoRef.getChangedBy(data.policyNo);
        },

        // 改变Tab
        changeTabs(value) {
            if (value == 'info') {
                this.$refs.infoRef.getInitList();
                this.$refs.infoRef.getChangedBy(this.formData.policyNo);
            } else if (value == 'status') {
                this.$refs.statusRef.getInitList();
                this.$refs.statusRef.getChangedBy();
            } else if (value == 'salesman') {
                this.$refs.salesmanRef.getInitList();
                this.$refs.salesmanRef.getChangedBy();
            }
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/.ivu-modal-body {
    padding-bottom: 30px !important;
}
</style>
